import {InjectionToken} from "@angular/core";

export const INT_TAG_TOKEN = new InjectionToken('int tag component');
